"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequestHandler = exports.HttpHeaders = exports.HttpMethod = void 0;
var axios_1 = __importDefault(require("axios"));
var endpoints_1 = require("../../constants/endpoints");
var cookies_1 = require("../../utils/cookies");
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["POST"] = "POST";
    HttpMethod["GET"] = "GET";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
var HttpHeaders;
(function (HttpHeaders) {
    HttpHeaders["AUTHORIZATION"] = "Authorization";
    HttpHeaders["API_KEY"] = "X-API-Key";
    HttpHeaders["APP_ID"] = "X-APP-ID";
    HttpHeaders["API_VERSION"] = "X-API-Version";
    HttpHeaders["USER_AGENT"] = "X-User-Agent";
})(HttpHeaders = exports.HttpHeaders || (exports.HttpHeaders = {}));
exports.createRequestHandler = function (_a) {
    var publicKey = _a.publicKey, appId = _a.appId, token = _a.token, customEndpoint = _a.customEndpoint;
    return {
        sendRequest: function (data, options) { return __awaiter(void 0, void 0, void 0, function () {
            var url, memberCookie, authHeader, formattedUrl, res, e_1;
            var _a, _b, _c;
            var _d, _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        _m.trys.push([0, 2, , 3]);
                        url = data.url;
                        memberCookie = cookies_1.getMemberCookie();
                        authHeader = [
                            (_e = (_d = data.headers) === null || _d === void 0 ? void 0 : _d["Authorization"]) === null || _e === void 0 ? void 0 : _e.replace("Bearer ", ""),
                            memberCookie,
                            options === null || options === void 0 ? void 0 : options.token,
                        ].find(function (x) { return x; });
                        formattedUrl = "" + (customEndpoint || endpoints_1.endpoints.API) + url;
                        return [4 /*yield*/, axios_1.default(__assign(__assign({}, data), { url: formattedUrl, headers: __assign(__assign(__assign(__assign({}, (authHeader && { authorization: "Bearer " + authHeader })), (publicKey && (_a = {}, _a[HttpHeaders.API_KEY] = publicKey, _a))), (appId && (_b = {}, _b[HttpHeaders.APP_ID] = appId, _b))), (_c = {}, _c[HttpHeaders.USER_AGENT] = "@memberstack/client@1.2.0", _c)), withCredentials: true }))];
                    case 1:
                        res = _m.sent();
                        if ((_f = res === null || res === void 0 ? void 0 : res.headers) === null || _f === void 0 ? void 0 : _f["ms-mid"]) {
                            token = res.headers["ms-mid"];
                        }
                        if ((_g = res === null || res === void 0 ? void 0 : res.data) === null || _g === void 0 ? void 0 : _g.error) {
                            if (res.data.error.name === "JsonWebTokenError") {
                                throw {
                                    code: "client/invalid-token",
                                    message: "An invalid token has been provided. Please make sure the token is valid.",
                                };
                            }
                            throw (_h = res.data) === null || _h === void 0 ? void 0 : _h.error;
                        }
                        return [2 /*return*/, res === null || res === void 0 ? void 0 : res.data];
                    case 2:
                        e_1 = _m.sent();
                        if (!e_1.response)
                            throw e_1;
                        throw ((_k = (_j = e_1.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.error) || ((_l = e_1.response) === null || _l === void 0 ? void 0 : _l.data);
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    };
};
